import {LicenseInfo} from '@mui/x-license';

import config from './config';
import {logStartupFeatureFlagEvaluations} from './logStartupFeatureFlagEvaluations';
import {debugCollector} from './setup';
import {markAppEntryBodyStarted} from './util/datadog/appEntryBodyTiming';
import {initDynamicImportErrorHandling} from './util/dynamicImportRetry';
import {prefetchViewerRampFlags} from './util/useRampFlag';

let initialized = false;

export function initializeAppStartup(): void {
  if (initialized) {
    return;
  }
  initialized = true;

  markAppEntryBodyStarted();
  LicenseInfo.setLicenseKey(
    '6bfd64b5485eccfeba7cbe13ff898697Tz0xMjQwNjYsRT0xNzk5NjI1NTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9bXVsdGksS1Y9Mg=='
  );

  if (config.ENVIRONMENT_IS_PRIVATE) {
    debugCollector.instrument();
  }

  initDynamicImportErrorHandling();
  logStartupFeatureFlagEvaluations();
  // Under the Forge shell the ARIA nav remote can run this before the app has
  // set its global history, so requests sent here see the shell's pathname and
  // fail the report route checks that attach `access-token`. Viewer-scoped
  // queries like this one don't need it; don't send project-scoped ones here.
  prefetchViewerRampFlags();
}
